import Uploader from '../../pulse/uploader'

onDomLoad(function () {
  const modal = document.querySelector(
    '[data-behaviour="document-uploader-modal"]:not([data-has-uploader])'
  )
  if (modal) {
    new Uploader(modal)
    modal.dataset.hasUploader = true
  }
})
